export default {
  notfound: '页面不存在',
  case_unavailable: '此判案书并不存在。',
  legis_unavailable: '此法例並不存在。',
  page_unavailable: '此页面并不存在。',
  bad_query: '系统未能处理你的搜索字串',
  noresult_warn: '没有结果符合该搜索条件',
  nodata_warn: '此数据库暂时没有任何文件',
  error: [
    '请使用搜寻器寻找其他文件，或{0}寻求技术支援。'
  ],
  case_onlyword: '此判案书暂时只提供 Word 版本下载。',
}